export default __webpack_public_path__ + "static/media/connect-page-image.46c6a036.png";